import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M26 4.33301C14.04 4.33301 4.33331 14.0397 4.33331 25.9997C4.33331 37.9597 14.04 47.6663 26 47.6663C37.96 47.6663 47.6666 37.9597 47.6666 25.9997C47.6666 14.0397 37.96 4.33301 26 4.33301ZM21.6666 35.7497V16.2497L34.6666 25.9997L21.6666 35.7497Z",
		fill: "#FF0606",
		fillOpacity: .54
	})
});
export default SvgPlayIcon;
